import script from "./SimilarSearchDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimilarSearchDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SimilarSearchDialog.vue?vue&type=style&index=0&id=2ba4af48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba4af48"]])

export default __exports__